export const SET_TOKEN_CREATE_NETWORK = 'SET_TOKEN_CREATE_NETWORK';
export const DELETE_TOKEN_CREATE_NETWORK = 'DELETE_TOKEN_CREATE_NETWORK';

export const SET_TOKEN_FORM_DATA = 'SET_TOKEN_FORM_DATA';
export const DELETE_TOKEN_FROM_DATA = 'DELETE_TOKEN_FROM_DATA';

export const SET_TOKEN_DEPLOY_DATA = 'SET_TOKEN_DEPLOY_DATA';
export const DELETE_TOKEN_DEPLOY_DATA = 'DELETE_TOKEN_DEPLOY_DATA';
